<div #mainBox [class.top-box]="isTopBox" [class.bottom-box]="isBottomBox" class="fluencyrate-box pointer"
    (clickOutside)="onClickOutside()" [additionalElementRefs]="extraBoxes">
    <div class="flag flex-column  no-select" (mousedown)="startLongPress()" (mouseup)="endLongPress($event)"
        (mouseleave)="endLongPress($event)" (touchstart)="startLongPress()" (touchend)="endLongPress($event)"
        (touchcancel)="endLongPress($event)" [class.smaller]="isStarted">

        <div class="duration-container" [class.blinking-effect]="isAlarmRinging" [class.smaller]="isStarted">
            <div *ngIf="isStarted">
                <p-checkbox inputId="happened" name="happened" [ngModel]="happened" [binary]="true"
                    (onChange)="setHappened($event)"></p-checkbox>
                <label for="happened">Happened</label>
            </div>
            <div class="duration-controls" [class.smaller]="isStarted">
                <button (click)="startTimer()" class="duration-button start-button">{{timerString()}}</button>
                <button *ngIf="isStarted" (click)="cancelTimer()" class="duration-button stop-button">
                    Stop
                </button>
            </div>

            <div class="flag-text">{{ text }}</div>
        </div>

        <span class="badge badge-left pointer" (click)="showExtra2()">{{ amountOfTimes }}</span>

        <button class="badge-bottom-left" (click)="openDetails($event)">?</button>
    </div>
</div>

@if (detailsOpened) {
<app-target-details [behavior]="behavior" (onCloseDetails)="onCloseDetails()" [isPreview]="isPreview"></app-target-details>
}

<div class="extra-container extra-big abc-container" #extraBox [class.hide]="!extraOpened">
    <app-abc-data-panel #abcDataPanel [behaviorID]="behaviorID" [sessionValue]="timerValue"
        (setExtraBoxesEvent)="setExtraBoxes()" [behaviorType]="behaviorType"></app-abc-data-panel>
</div>

<div class="extra-container" #extraBox2 [class.hide]="!extra2Opened">
    <div class="extra-close" (click)="closeExtra2()">X</div>
    <div class="extra-container-textbox">
        <div *ngFor="let interval of intervals">
            <span class="float-right extra-list-trash-icon pointer" (click)="deleteData(interval)"><i
                    class="pi pi-trash"></i></span>
            {{ interval.FormattedDate }} - {{ interval.happened ? 'Happened' : 'Didn´t happened' }}

            <button class="abc-add-button-duration" (click)="addABCData(interval)" *ngIf="!hasABCData(interval)">+ Add
                ABC Data</button>
            <button class="abc-add-button-duration" (click)="seeABCData(interval)" *ngIf="hasABCData(interval)">See ABC
                Data</button>
        </div>
        <div *ngIf="!intervals.length">
            There is no data for this behavior yet.<br>
            First record some data and then add ABC Data.
        </div>
    </div>
</div>